<template>
  <b-container>
    <div class="wrapper box-shadow">
      <b-row class="align-items-center img-panel">
        <div class="col text-center my-3">
            <img src="../assets/404.svg" alt="">
            <br>
            <br>
            <br>
            <h4>Whoops. Looks like this page doesn't exist.</h4>
        </div>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
<style lang="scss" scoped>
.img-panel {
  min-height: 480px;
}
.img-panel img{
  width: 128px;
  height: 128px;
}
</style>


